import type { OperatorAttachedFile } from "@lib/agenticAi/types";

import type { CampaignBriefOperatorAttachedFile } from "./types";

export const toOperatorAttachedFile = (descriptor: CampaignBriefOperatorAttachedFile): OperatorAttachedFile => ({
  url: descriptor.url,
  fileName: descriptor.file_name,
  mimeType: descriptor.mime_type,
  context: descriptor.context,
  expiresAt: descriptor.expires_at,
  fileUpdatedAt: descriptor.file_updated_at ?? undefined,
});
